import {
  List as MantineList,
  ListProps as MantineListProps,
} from '@mantine/core';
import { forwardRef } from 'react';

import styles from './List.module.css';

export type ListProps = Omit<
  MantineListProps,
  'color' | 'styles' | 'classNames' | 'style'
>;

const classNames = {
  root: styles.root,
  item: styles.item,
  itemIcon: styles.itemIcon,
  itemLabel: styles.itemLabel,
  itemWrapper: styles.itemWrapper,
};

type ListComponent = React.ForwardRefExoticComponent<
  ListProps & React.RefAttributes<HTMLUListElement>
> & {
  Item: typeof MantineList.Item;
};

export const List = forwardRef<HTMLUListElement, ListProps>(
  ({ ...props }, ref) => {
    return (
      <MantineList
        ref={
          ref as unknown as React.Ref<HTMLUListElement> &
            React.Ref<HTMLOListElement>
        }
        unstyled
        classNames={classNames}
        {...props}
      />
    );
  }
) as ListComponent;

List.displayName = 'List';
List.Item = MantineList.Item;
